import styled from 'styled-components';

export const ContainerOuter = styled.div`
    background: #fff;
    min-height: 100vh;
`;

export const Container = styled.div`
    padding: 50px 20px;
    @media (max-width: 1000px){
        padding: 25px 0;
    }
`;

export const LoaderContainer = styled.div`
    min-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FormContainer = styled.div`
    width: 84%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 45% 50%;
    grid-column-gap: 8%;
    margin-top: 25px;
    @media (max-width: 1000px){
        width: 96%;
        grid-template-columns: 40% 60%;
        grid-column-gap: 1%;
    }
    @media (max-width: 750px){
        display: flex;
        flex-direction column;
    }
`;

export const FieldsContainer = styled.div`
    border-radius: 5px;
    background: #fafafa;
    padding: 20px;
    @media (max-width: 750px){
        padding: 10px;
    }
`;

export const MetaContainer = styled.div`
    margin: 30px 0;
`;

export const TypesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Type = styled.div`
    cursor: pointer;
    color: ${props => props.selected ? '#121180' : '#fff'};
    background: ${props => props.selected ? '#fff' : '#121180'};
    border: 1px solid #121180;
    border-radius: 4px;
    font-size: 14px;
    padding: 8px 20px;
    margin: 10px 15px 10px 0;
    :hover{
        opacity: 0.9;
    }
`;

export const ClickedFieldContainer = styled.div`
    background: #fff;
    padding: 20px;
    margin-top: 25px;
`;

export const WorkFlowActionsContainer = styled.div`
    margin: 25px 0;
    padding: 15px 20px;
    background: #fff;
    border-radius: 3px;
    position: relative;
`;

export const AddedFieldsContainer = styled.div`
    border-radius: 5px;
    background: #fafafa;
    padding: 20px;
    @media (max-width: 750px){
        padding: 5px;
    }
`;

export const DataContainer = styled.div`
    display: grid;
    grid-template-columns: 5% 75% 5% 6% 4%;
    align-items: center;
    padding: 5px 25px;
    background: #fff;
    border-radius: 5px;
    margin: 13px 0;
    border: ${props => props.isDragging ? "2px solid red" : ""};
    @media (max-width: 750px){
        padding: 5px;
        margin: 10px 0;
        grid-template-columns: 7% 76% 3% 5% 5%;
    }
`;